import React, { useState, useEffect } from 'react';
import { pageService } from '../services/api';
import office4 from '../images/office4.jpg';
import office2 from '../images/office2.jpg';
const ControllerMessage = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const response = await pageService.getPageBySlug('messageFromControllerExaminations');
        setContent(response?.data?.page || null);
      } catch (err) {
        console.error('Failed to load controller message:', err);
        setContent(null);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading || !content) return null;

  return (
    <div className="col-md-3 card ms-3 me-3 pt-3 m-ms-0 left-right-boxes" id="messageFromControllerExaminations">
        <h5 className="aboutus-title">{content.title}</h5>
      {content.sidebar_content && (
        <div className="img-wrapper">
          <img src={`/uploads/${content.sidebar_content}`} alt={content.title} className="img-fluid" />
        </div>
      )}
      
      <div dangerouslySetInnerHTML={{ __html: content.content }} />
    </div>
  );
};

export default ControllerMessage;
